import { ReactNode, memo } from "react";

import Footer from "@/components/Footer";
import FloatingButtons from "@/components/FloatingButtons";

import AccessibilityEnhancer from "@/components/common/AccessibilityEnhancer";
import { useEditMode } from "@/context/EditModeContext";
import { Pencil } from "lucide-react";
interface MainLayoutProps {
  children: ReactNode;
}
const MainLayout = memo(({
  children
}: MainLayoutProps) => {
  const {
    isEditMode,
    toggleEditMode
  } = useEditMode();
  return <>
      <AccessibilityEnhancer />
      
      <div className="min-h-screen bg-garage-dark text-white overflow-x-hidden" style={{
      transform: 'translateZ(0)'
    }}>
        
        <main id="main-content" role="main" aria-label="Główna treść strony">
          {children}
        </main>
        <Footer />
        <FloatingButtons />
      </div>
    </>;
});
export default MainLayout;